// eslint-disable-next-line @typescript-eslint/ban-types
export const runInSequence = async (functions: Array<Function>) => {
  return await functions.reduce(async (promise, func) => {
    await promise;
    return await func();
  }, Promise.resolve([]));
};
